import { priceFormatter } from '@2wunder/klarx-tool'
import { MemberProps } from 'app/components/Core/convention'
import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import Icon from 'app/components/UI-Elements/General/Icon'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { isNull } from 'lodash'
import { FC, ReactNode } from 'react'
import testIds from 'test_ids.json'

import KUnit from './KUnit'

type PricingAttributes = 'total' | 'displayDiscountedUnitPrice' | 'discounted_unit_price'

type PriceItem = Pick<ISubItem, PricingAttributes | 'unit' | 'freeAttachment' | 'id'>
type Props = {
  type?: 'tag' | 'span'
  attribute?: PricingAttributes
  rightElement?: FC | ReactNode
}

const KPriceInfo: React.FC<MemberProps<PriceItem, Props>> = ({ member, props }) => {
  const { type = 'tag', attribute = 'discounted_unit_price', rightElement = null } = props || {}
  const { unit, freeAttachment, id } = member || {}
  const { tAttribute } = ToolBox.useString()
  const formatted_unit_price = priceFormatter(member[attribute])

  const Price = () => {
    if (!isNull(rightElement)) {
      return (
        <>
          {formatted_unit_price} {rightElement}
        </>
      )
    }

    return (
      <>
        {formatted_unit_price} / <KUnit member={unit} props={{ count: 1, omitCount: true }} />
      </>
    )
  }

  return (
    <Choose>
      <When condition={type === 'tag'}>
        <If condition={formatted_unit_price}>
          <KTag
            text={<Price />}
            type="info"
            dataTestId={`${testIds.modules.data_display.KPriceInfo}-${id}-${attribute}`}
            icon={
              <Icon iconStyles={{ width: 18, height: 18, verticalAlign: '-0.3em' }} type="euro" />
            }
          />
        </If>
      </When>
      <Otherwise>
        <If condition={member[attribute] > 0}>
          <span>
            <Price />
          </span>
        </If>
        <If condition={freeAttachment}>
          <span>
            {tAttribute({
              recordType: RecordType.line_item,
              attribute: 'inclusive'
            })}
          </span>
        </If>
      </Otherwise>
    </Choose>
  )
}

export default KPriceInfo
